const isPostHogAvailable = () => typeof window.posthog !== 'undefined';

export const trackEvent = (eventName, properties = {}) => {
  if (isPostHogAvailable()) {
    window.posthog.capture(eventName, properties);
  } else if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log(`[Tracking] ${eventName}`, properties);
  }
};

export const identifyUser = (userId, traits = {}) => {
  if (isPostHogAvailable()) {
    window.posthog.identify(userId, traits);

    if (Object.keys(traits).length > 0) {
      window.posthog.people.set(traits);
    }
  } else if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log(`[Identify] User: ${userId}`, traits);
  }
};

// Export all functions as default for easier imports
export default {
  trackEvent,
  identifyUser,
};
